import { Paper, Typography, useTheme } from '@material-ui/core'

import { InventoryHealthDiagnostic } from '../../types/inventoryHealth'
import {
  findingKey,
  findingParts,
  statusColor,
  verdictColor,
  verdictText
} from './findings'
import useStyles from './styles/InventoryHealthVerdict.styles'

export default function InventoryHealthVerdict({
  result
}: {
  result: InventoryHealthDiagnostic
}) {
  const classes = useStyles()
  const isDark = useTheme().palette.type === 'dark'

  return (
    <Paper className={classes.panel} aria-live="polite">
      <Typography
        variant="subtitle1"
        style={{
          color: verdictColor(result.overallStatus, result.totalRows, isDark)
        }}>
        {verdictText(
          result.overallStatus,
          result.totalRows,
          result.differingRows
        )}
      </Typography>

      {result.findings.map((finding) => (
        <Typography
          key={findingKey(finding)}
          variant="body2"
          className={classes.finding}
          style={{ color: statusColor(finding.severity, isDark) }}>
          {/*
            The label must lead. The server sets detail to a bare "N row(s)
            affected." for every counted finding, so rendering detail alone
            produced a column of numbers with nothing saying what they counted.
          */}
          <strong>{findingParts(finding).label}</strong>
          {` — ${findingParts(finding).detail}`}
          <br />
          <span className={classes.explanation}>
            {findingParts(finding).explanation}
          </span>
        </Typography>
      ))}
    </Paper>
  )
}
